// extracted by mini-css-extract-plugin
module.exports = {"txt":"index-module__txt___E0Ce+"};